import LeadForm from "@/components/LeadForm";
import { useSettings } from "@/lib/settings";
import { Mail, Phone, MapPin, Clock } from "lucide-react";

export default function ContactPage() {
  const { settings } = useSettings();
  if (!settings) return null;
  const c = settings.contact;

  return (
    <div className="pt-12 pb-24">
      <div className="container-eq">
        <div className="max-w-3xl">
          <div className="label-eq text-sky-500 mb-3">Contact</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tighter" data-testid="contact-title">Let's talk about your career</h1>
          <p className="mt-4 text-neutral-600">Fill in the form or reach out through any of the channels below.</p>
        </div>

        <div className="grid lg:grid-cols-5 gap-10 mt-14">
          <div className="lg:col-span-2 space-y-4">
            <div className="p-6 card-eq" data-testid="contact-phone">
              <Phone className="w-6 h-6 text-sky-500" />
              <div className="mt-3 label-eq text-neutral-500">Call us</div>
              <div className="font-display font-bold text-lg mt-1">{c.phone}</div>
            </div>
            <div className="p-6 card-eq" data-testid="contact-email">
              <Mail className="w-6 h-6 text-sky-500" />
              <div className="mt-3 label-eq text-neutral-500">Email</div>
              <div className="font-display font-bold text-lg mt-1">{c.email}</div>
            </div>
            <div className="p-6 card-eq" data-testid="contact-address">
              <MapPin className="w-6 h-6 text-sky-500" />
              <div className="mt-3 label-eq text-neutral-500">Address</div>
              <div className="font-display font-bold text-lg mt-1">{c.address}</div>
            </div>
            <div className="p-6 card-eq">
              <Clock className="w-6 h-6 text-sky-500" />
              <div className="mt-3 label-eq text-neutral-500">Working Hours</div>
              <div className="font-display font-bold text-lg mt-1">{c.hours}</div>
            </div>
          </div>
          <div className="lg:col-span-3 card-eq p-8">
            <h2 className="font-display font-bold text-2xl mb-6">Send us a message</h2>
            <LeadForm source="contact_page" />
          </div>
        </div>

        {c.map_url && (
          <div className="mt-14 rounded-3xl overflow-hidden border border-neutral-200" data-testid="contact-map">
            <iframe
              title="Location map"
              src={c.map_url.startsWith("http") ? c.map_url.replace("/?q=", "?output=embed&q=").replace("maps.google.com", "www.google.com/maps") : c.map_url}
              className="w-full h-[400px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        )}
      </div>
    </div>
  );
}
